// extracted by mini-css-extract-plugin
module.exports = {"langIcon":"LangIcon-module--lang-icon--2kdKB"};